import React from "react"
import ReactDOM from "react-dom/client"

import { SearchspringSearchProvider } from "@app/scripts/providers/searchspring"
import { SearchGrid, type Props } from "./component"

const App = class extends HTMLElement {
  root: ReactDOM.Root | null = null

  connectedCallback() {
    const props: Partial<Props> = {}

    this.querySelectorAll("script").forEach((script) => {
      try {
        const data = JSON.parse(script?.innerHTML)
        const name = script.getAttribute("name")

        if (!name) return

        props[name as keyof Props] = data
      } catch (error) {
        console.error(error)
      }
    })

    const params = new URLSearchParams(window.location.search)
    const query = params.get("query") || ""
    const sort = params.get("sort") || ""
    const filters = params.get("filters") || ""
    const page = params.get("page") || ""
    const tag = params.get("tag") || ""

    if (!this.root) this.root = ReactDOM.createRoot(this)
    this.root.render(
      <SearchspringSearchProvider
        category="products"
        resultsPerPage="24"
        query={query}
        sort={sort && sort}
        filters={filters && filters.split(",")}
        page={page && page}
        tag={tag && tag}
      >
        <SearchGrid {...(props as Props)} query={query} />
      </SearchspringSearchProvider>
    )
  }
}

customElements.define("ss-search-grid", App)
